var exports = {
  "y": "linkedPullRequestLink__YiBqgz",
};

module.exports = exports;
